import { Model } from '@vuex-orm/core';
import Residence from '@/models/Residence';
import FacilityResidence from './FacilityResidence';

export default class Facility extends Model {
  static entity = 'facilities';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      residences: this.belongsToMany(Residence, FacilityResidence, 'facility_id', 'residence_id'),
    }
  }

  static transformer(data) {
    const facilities = [];
    data.data.forEach(item => {
      const facility = {};
      facility.id = item.id;
      facility.name = item.name;
      facility.slug = item.slug;
      facility.count = item.count;
      facility.description = item.description;
      facilities.push(facility);
    })
    return facilities;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL) {
    let url = '/wp-json/wp/v2/facility?per_page=100';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}